import { renderSearchPanel } from '@pc/components/Works/Panel'

document.addEventListener('DOMContentLoaded', () => {
  renderSearchPanel()
})
